module.exports = __webpack_public_path__ + "img/loading.d52105b4.svg";